import { APP_ENV } from '@/common/const/env.const'

export const APP_CONFIG = {
  OPERATOR: 'ENEA',
  [APP_ENV.development]: {
    API: '',
    SENTRY: ''
  },
  [APP_ENV.production]: {
    API: '',
    SENTRY: 'https://7293280eda2645bd9971bb3c45cdb4e2@error.blue.pl/170'
  }
}
